import type {ListPermissionsSearchInput} from "./list-permissions.schema";
import {keepPreviousData, useQuery} from "@tanstack/react-query";
import {listPermissionsQueryOptions} from "./list-permissions.query-options";

export function useListPermissions(input: ListPermissionsSearchInput) {
  return useQuery({...listPermissionsQueryOptions(input), placeholderData: keepPreviousData});
}
